import withStyles from '@mui/styles/withStyles';
import Typography from '@classify/react-core-components/Typography';

const styles = /* istanbul ignore next */ (theme) => ({
  icon: {
    height: '18px',
    width: '18px',
    marginRight: theme.spacing(1),
    verticalAlign: 'middle',
  },
  root: {
    color: 'inherit',
    display: 'inline-block',
    wordBreak: 'keep-all',
    marginRight: theme.spacing(3),
  },
  text: {
    verticalAlign: 'middle',
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
});

export function Metadata({
  accessibilityLabel = '',
  children = null,
  classes = {},
  className = '',
  icon: Icon = null,
  shouldNotWrap = false,
}) {
  return (
    <Typography
      component="span"
      className={`${classes.root} ${className} ${shouldNotWrap ? classes.noWrap : ''}`}
      variant="bodySmall"
    >
      {Icon && <Icon className={classes.icon} titleAccess={accessibilityLabel} />}
      <span className={classes.text}>{children}</span>
    </Typography>
  );
}

/**
 * @deprecated
 * ### Description
 * `Metadata` has been deprecated and replaced by Classify `ProductMetadata`.
 *
 * ### Example
 * ```
 * import ProductMetadata from '@classify/react-product-components/ProductMetadata';
 * ```
 */
export default withStyles(styles)(Metadata);
